import React, { Component } from 'react';
import { Button, Spin } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import ExportUtil from '../../../common/ExportUtil';
import ExecuteSider from '../ExecuteSider';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const monthFormat = 'YYYY-MM';

class Filter extends Component {
    render() {
        const { visitType, ...rest } = this.props;
        const { siteId } = sessionStorage;
        const filters = [{
            name: '时间',
            key: 'startDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '|',
            key: 'endDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }];
        if (siteId == 0) {
            filters.push({
                name: '中心',
                key: 'investigationSite',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'searchKey',
                    style: {width: 160},
                    placeholder: '输入中心编号/名称检索',
                    params: {limit: 20},
                    url: API_URL.site.list,
                    config: { id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'site' },
                }
            });
        }
        filters.push({
            name: '访视类型',
            key: 'visitConfigId',
            type: 'select',
            typeProperty: {
                style: { width: 240 },
                list: visitType,
            }
        });
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

class StandardVisitNum extends Component {
    constructor(props) {
        super(props);
        const { siteId } = sessionStorage;
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams: {
                investigationSiteId: siteId > 0 ? siteId : '',
                startDate: moment().subtract(11, 'M').format(monthFormat),
                endDate: moment().format(monthFormat),
            },
            pagination: {
                pageSize: 10,
                current: 1,
            },
            visitType: [],
        };
    }

    componentDidMount() {
        this.loadData();
        this.queryVisitType();
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.execute.queryStandardVisitNum,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    queryVisitType = () => {
        const options = {
            method: 'POST',
            url: API_URL.execute.queryPerformanceWeightByType,
            data: { type: 'VISIT_TYPE' },
            dataType: 'json',
            doneResult: res => {
                const visitType = (res.data || []).map(i => ({ label: i.typeValue, value: i.relatedId }));
                this.setState({ visitType });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        const url = API_URL.execute.exportStandardVisitNum;
        ExportUtil.export({ ...sortParams, ...params }, null, url);
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleStringLinefeed = (text) => {
        const arr = (text || '').split(',');
        const result = arr.map((item, index) => {
            return <span key={index}>{item}{index < arr.length - 1 ? ',' : ''}<br /></span>;
        });
        return result;
    }

    getColumns = () => {
        const columns = [{
            title: '日期',
            dataIndex: 'dateStr',
            key: 'dateStr',
            sorter: true,
            fixed: 'left',
            width: 90,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            sorter: true,
            fixed: 'left',
            width: 100,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            sorter: true,
            width: 200,
        }, {
            title: '访视类型',
            dataIndex: 'visitName',
            key: 'visitName',
            width: 200,
        }, {
            title: '实际访视数',
            dataIndex: 'visitCount',
            key: 'visitCount',
            width: 100,
        }, {
            title: '标准访视数',
            dataIndex: 'standardNum',
            key: 'standardNum',
            width: 100,
        }, {
            title: '完成访视者',
            dataIndex: 'userCompellations',
            key: 'userCompellations',
            width: 100,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, visitType, pagination, searchParams, sortParams } = this.state;
        return (
            <div className="content">
                <ExecuteSider selectKey='standardVisitNum' />
                <div className="main">
                    <Filter
                        search={this.search}
                        params={searchParams}
                        visitType={visitType}
                        onChange={this.handleFilterChange}
                        buttons={[
                            <Button key="export" type="primary" onClick={this.export}>导出</Button>
                        ]}
                    />
                    <Spin spinning={loading}>
                        <TableC
                            data={data}
                            sortParams={sortParams}
                            columns={this.getColumns()}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                    </Spin>
                </div>
            </div>
        );
    }
}

export default StandardVisitNum;


// WEBPACK FOOTER //
// ./src/components/execute/standardVisitNum/index.js